// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/VendasKpi_FidelizadosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /dashboards/vendas_kpi/fidelizados.
 *
 * Returns one VendasKpi_FidelizadosMesRow per month, ordered ascending,
 * covering the last 12 months.
 */
import type { VendasKpi_FidelizadosMesRow } from './VendasKpi_FidelizadosMesRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface VendasKpi_FidelizadosResponseDados {
meses: VendasKpi_FidelizadosMesRow[]
}

export type VendasKpi_FidelizadosResponse = ApiResponse<VendasKpi_FidelizadosResponseDados>;

registerResponseContract('VendasKpi_FidelizadosResponse', {
  meses: {
    type: 'array',
    required: true,
    items: {
      mes:                  { type: 'string',  required: true },
      total_clientes:       { type: 'number',  required: false },
      clientes_fidelizados: { type: 'number',  required: false },
    },
  },
})
